export var styleMap = {
  LIGHTCOLOR: {
    color: '#828285'
  },
  BOLD: {
    fontWeight: '600'
  }
};